/* eslint-disable */
import { client } from "./axiosClient";

export const performOnePageApprovalAction = (payload) => 
  // payload: { onepage_id, action, comment }
  client.post("/api/onepage-approval-action/", payload).then(res => res.data);